<template>
<div class="container">

	<div class="row">
		<div class="card">
      <div class="card-body">
				<h3 class="display-5">Online Store by SignLedger</h3>
				<br>
				<div class="text-left">
					<ul>
            <li>Create and manage online product catalog</li><br>
						<li>Allow customers to place order requests online</li><br>
						<li>Manage order pipeline with - 
              <a href="https://orders.signledger.com" target="_blank">orders.signledger.com</a>
            </li><br>
						<li>Manage product inventory with - 
              <a href="https://inventory.signledger.com" target="_blank">inventory.signledger.com</a>
            </li><br>
					</ul>
        </div>
      </div>
		</div>
  </div>

</div>
</template>

<script>

export default {
  components: {
  },

  data() {
    return {
    }
  },

  methods: {
  }
}
</script>

<style scoped>
</style>
